/**
 * AdSense publisher config.
 * Keep slot IDs empty until units are created and content review is ready.
 * Client script in index.html is enough for site verification.
 */
export const adsConfig = {
  /** Script/verification may be on; empty slots mean no creatives render. */
  enabled: true,
  provider: 'adsense' as const,
  clientId: 'ca-pub-9149142349303371',
  slots: {
    /** Only used on substantial routes (guides, methodology, about, changelog). */
    pageTop: '',
    pageBottom: '',
    /** Kept empty — do not place in-feed ads on thin catalog templates until approved. */
    inFeed: '',
  },
  /**
   * Routes where AdSlot may render once slot IDs are filled.
   * Drink detail and generic catalog in-feed stay excluded (low-value template risk).
   */
  allowedPathPrefixes: [
    '/guides',
    '/methodology',
    '/about',
    '/changelog',
  ] as const,
  /**
   * Google-certified CMP (e.g. Funding Choices / AdSense Privacy & messaging).
   * Enable after configuring the message in AdSense; Privacy copy references this.
   */
  cmp: {
    enabled: false,
    /** Optional Funding Choices / adsense privacy script loader hook. */
    fundingChoicesScriptUrl: '' as string,
  },
  /** Show labeled development placeholders when ads are disabled. */
  showPlaceholdersInDev: true,
} as const;

export type AdsConfig = typeof adsConfig;

export function adsAllowedForPath(pathname: string): boolean {
  const path = pathname.endsWith('/') && pathname.length > 1
    ? pathname.slice(0, -1)
    : pathname;
  return adsConfig.allowedPathPrefixes.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
